import { render, staticRenderFns } from "./ContactEditDialog.vue?vue&type=template&id=4ff0b955&scoped=true"
import script from "./ContactEditDialog.vue?vue&type=script&lang=js"
export * from "./ContactEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0b955",
  null
  
)

export default component.exports